module.exports = __webpack_public_path__ + "img/195.0616fb28.jpg";